import '.bq{flex-shrink:0;}.ssr-plugin'
import '.bs{padding:1rem;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.bn{height:100%;}.ssr-plugin'
import '.bb{border:none;}.ssr-plugin'
import '.bc{background-color:transparent;}.ssr-plugin'
import '.e8{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ak{align-items:stretch;}.ssr-plugin'
import '.do{position:sticky;}.ssr-plugin'
import '.e9{top:4rem;}.ssr-plugin'
import '.ea{z-index:7;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.eb{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.ec{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.ch{top:0;}.ssr-plugin'
import '.bl{left:0px;}.ssr-plugin'
import '.bm{right:0px;}.ssr-plugin'
import '.ed{bottom:0px;}.ssr-plugin'
import '.ee{z-index:9999;}.ssr-plugin'
import '.ef{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d2{justify-content:flex-end;}.ssr-plugin'
import '.c6{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bq bs x bn bb bc e8"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ak"
    >
      <div className="do e9 ea ac eb v ec a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a2 ch bl bm ed ee ac ef a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bs a d2 ec"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c6 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
